<template>
    <div id="inventory">

        <el-row style="display: flex;flex-wrap: wrap;">
            <el-col v-if="onoffManager">
                <el-button type="success" size="small" @click.stop="newAddTodoClick"   style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;font-size: 13px">
                    <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                    添加
                </el-button>
            </el-col>
            <el-col v-for="(item,j) in todoList" style="border: 1px solid #ededed;width: 400px;margin-top: 10px;margin-right: 20px">
                <p style="font-size: 20px;color: #4D586D;padding-left: 20px;margin:0;padding-top: 10px" v-if="disabled1">{{item.title}}<span style="float: right;cursor:pointer;margin-right: 20px;color: #ff9901;font-size: 15px;" @click.stop="editorTodoList(item)"  @click="addTodoBool=true">编辑</span></p>
                <p style="font-size: 14px;color: #B0B5B9;padding-left: 20px;margin:0;padding-top: 10px">
                    <span >{{item.distributor_name}}</span>
                    <span v-if="item.department">{{item.department}} |</span>
                    <span v-if="item.job_title">{{item.job_title}} |</span>
                    <span v-if="item.contact_name"> {{item.contact_name}}</span>
                </p>
                <p style="color: #4ec880;font-size: 15px;padding: 10px 0 10px 20px;margin:0">截止日期：{{item.duedate| componentFliter}}</p>
            </el-col>
        </el-row>

        <!--        添加待办事项-->
        <el-dialog
                :visible.sync="addTodoBool"
                width="800px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div id="addTodo" style="margin-top:10px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">添加待办事项
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.stop="inputEditInventoryInfo" >
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.stop="closeAddTodoBool">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin-top: 20px;">
                    <el-form ref="formlist" :model="addTodo" label-width="15%" style="margin-left: 110px" hide-required-asterisk >
                        <el-form-item label="标题" class="addTodoList_star" :rules="[{required:true,message:'标题不能为空'}]" prop="title">
                            <el-input v-model="addTodo.title" placeholder="请填写标题"  style="width: 70%;margin-left:5%;" ></el-input>
                        </el-form-item>
                        <el-form-item label="截止日期" class="addTodoList_star" :rules="[{required:true,message:'截止日期不能为空'}]" prop="duedate">
                            <el-date-picker
                                    v-model="addTodo.duedate"
                                    format="yyyy-M-d"
                                    value-format="yyyy-MM-dd"
                                    placeholder="请选择截止日期"
                                    :picker-options="pickerOptions"
                                    style="width: 70%;margin-left:5%;">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="关联对象" >
                            <p style="color: #3b99f7;font-size: 14px; margin-top: 0px;margin-bottom: 0px;margin-left:5%;">
                                {{addTodo.distributor_name}} |
                                <span v-if="addTodo.department">{{addTodo.department}} |</span>
                                <span v-if="addTodo.job_title">{{addTodo.job_title}} |</span>
                                <span v-if="addTodo.contact_name">{{addTodo.contact_name}}</span>
                            </p>
                        </el-form-item>
                        <el-form-item label="说明" >
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请填写说明"
                                    v-model="addTodo.content"
                                    style="width: 70%;margin-left:5%;">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="上传照片">
                            <el-upload
                                    ref="displayUpload"
                                    :limit="9"
                                    accept=".jpg,.png,.jpeg"
                                    action="/photos/uploadphoto"
                                    list-type="picture-card"
                                    :on-preview="dialogVisibles"
                                    :on-remove="handleRemove"
                                    :on-change="handleChange"
                                    :on-success="handleImgSuccess"
                                    :before-upload="beforeImgUpload"
                                    :data="displayChecImgData"
                                    :file-list="fileList"
                                    style="margin-left:5%;">

                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <p style="line-height:20px;margin-left:5%;">你可以上传多张JPG或PNG格式的图片文件,
                                单个文件大小不能超过20M。</p>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-dialog>

        <el-dialog :visible.sync="dialogVisibleImg">
            <img width="100%" height="100%" style="margin-top:20px;" :src="dialogSrc" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../APIService/http'
    import moment from 'moment'
    export default {
        name: "addTodoList",
        props:{
            onoffManager:{
                type:Boolean,
                default:true
            },
            title:{
                type:String,
                default:''
            }
        },
        data(){
            return{
                displayChecImgData:{
                    reference_obj: 'CLIENT',
                    reference_id: 'com.saasyun.android',
                    credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    username:this.$store.getters.getUser.username,
                    user_id:this.$store.getters.getUser.user_id,
                    event_obj : 'CAMPAIGN',
                    category:'TODO',
                },
                fileList:[],
                copyFileList: [],
                dialogSrc:'',
                dialogVisibleImg:false,
                addTodoBool:false,
                addTodo:{
                    duedate:''
                },
                pickerOptions:{
                    disabledDate: (time) => {
                        return time.getTime() + 24 * 3600 * 1000 < Date.now() || time.getTime() > Date.now() + 30*24 * 3600 * 1000
                    }
                },
                todoList:[],
                disabled1:true,
                onoffManager:true,
                title:''
            }

        },
        filters:{
            componentFliter:function (value) {
                return moment(value).format('YYYY年M月D日')
            },
        },
        created () {
            if(this.onoffManager){
                if(this.$route.params.created_by === this.$store.getters.getUser.user_id){
                    this.disabled = false
                }else{
                    this.disabled = true
                }
            }else {
                this.disabled1 = false
            }
            this.init()
        },
        mounted () {
            let user = this.$store.getters.getUser
            if(this.onoffManager){
                if (user.role !== 'staff' && this.$route.params.created_by !== user.user_id) {
                    this.onoffManager =false
                }
            }else {
                this.disabled1=false
            }

        },
        methods: {
            dialogVisibles(file) {
                this.dialogSrc = file.url
                this.dialogVisibleImg = true
            },
            handleRemove(file, fileList) {
                this.fileList = fileList
            },
            handleChange(file, fileList){
                this.fileList = fileList
                console.log(this.fileList)
            },
            // 上传图片成功
            handleImgSuccess(response, file, fileList) {
                // console.log(file)
                // this.fileList.push({
                //     name: file.name,
                //     url: file.url,
                //     response : file.response
                // });
                // this.editInventoryInfo()
            },
            beforeImgUpload(file) {


                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
                const isLt20M = file.size / 1024 / 1024 < 20 * 1.2
                this.file_size = file.size

                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
                if (!isLt20M) {
                    this.error('上传图片大小不能超过 20MB!')
                }
                const nameArr = file.name.split('.')
                return isPic && isLt20M
            },

            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let condition = localStorage.getItem('condition')
                    let obj = JSON.parse(condition)
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        activity_id:this.$route.params.activity_id || obj.activity_id,
                    }
                    await http.post('/wapi/Business/getTodoByDistributorVisit',data).then(res=>{
                        if(res.success == true){
                            this.todoList = res.data
                            for(let k=0;k<res.data.length;k++){
                                let photoList = res.data[k].photoList
                                for (let j = 0; j<photoList.length;j++ ){
                                    this.getImgUrl(photoList[j].photo_id,photoList[j].created_date,photoList[j],photoList)
                                }

                            }

                        }

                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            newAddTodoClick(){
                this.addTodo = {
                    content:'',
                    title:'',
                    duedate:'',
                }
                this.addTodoBool=true
                this.fileList = []
                this.copyFileList = []
                this.addTodo.distributor_name = this.$route.params.distributor_name
                this.$refs['formlist'].resetFields()

            },
            inputEditInventoryInfo(){
                this.$refs["formlist"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                        let onoff = true
                        for (let i=0;i<this.fileList.length;i++){
                            if (this.fileList[i].status !== "success") {
                                onoff = false
                                break
                            }
                        }
                        if (onoff){
                            this.editInventoryInfo()
                        } else {
                            this.$message({
                                type:'warning',
                                message: '请等待图片上传完成后重试'
                            })
                        }

                    }
                })
            },
            // 保存
            async editInventoryInfo(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    if(this.addTodo.todo_id){
                        let data={
                            tenant_id:this.$store.getters.getUser.tenant_id,
                            user_id:this.$store.getters.getUser.user_id,
                            title:this.addTodo.title,
                            content:this.addTodo.content,
                            duedate:this.addTodo.duedate,
                            reference_obj:this.addTodo.reference_obj,
                            reference_id:this.addTodo.reference_id,
                            call_id:this.$route.params.activity_id,
                            todo_id:this.addTodo.todo_id,
                        }
                        data.fileList = this.fileList


                        data.imageIdArray = []   //需要添加图片的数组
                        data.deleteImageIdArray = []  //需要删除图片的数组
                        let imgArrayList = []
                        let copyFileList = this.copyFileList //拿没有新增和删除之前的图片数组
                        //处理数组  找出所有添加图片的数组
                        for (let i=0;i<this.fileList.length;i++){
                            if (this.fileList[i].response){   //如果有 response 这个属性则为添加的图片
                                let obj = this.fileList[i].response.data
                                data.imageIdArray.push(obj)
                            } else {
                                imgArrayList.push(this.fileList[i])
                            }

                        }
                        //处理数组  找出所有删除图片的数组
                        for(var i = 0; i < copyFileList.length; i++){
                            var obj = copyFileList[i];
                            var num = obj.photo_id;
                            var flag = false;
                            for(var j = 0; j < imgArrayList.length; j++){
                                var aj = imgArrayList[j];
                                var n = aj.photo_id;
                                if(n === num){
                                    flag = true;
                                    break;
                                }
                            }
                            if(!flag){
                                data.deleteImageIdArray.push(obj);
                            }
                        }


                        await http.post('/wapi/Business/addOrEditTodoByDistributor',data).then(res=>{
                            if(res.success == true){
                                this.init()
                                this.$message({
                                    type:'success',
                                    message:'保存成功'
                                })
                                this.addTodoBool = false
                            }
                        })
                    }else{
                        let data={
                            tenant_id:this.$store.getters.getUser.tenant_id,
                            user_id:this.$store.getters.getUser.user_id,
                            title:this.addTodo.title,
                            content:this.addTodo.content,
                            duedate:this.addTodo.duedate,
                            reference_obj:'DISTRIBUTOR',
                            reference_id:this.$route.params.distributor_id,
                            call_id:this.$route.params.activity_id,
                        }
                        data.fileList = this.fileList


                        data.imageIdArray = []   //需要添加图片的数组
                        data.deleteImageIdArray = []  //需要删除图片的数组
                        let imgArrayList = []
                        let copyFileList = this.copyFileList //拿没有新增和删除之前的图片数组
                        //处理数组  找出所有添加图片的数组
                        for (let i=0;i<this.fileList.length;i++){
                            if (this.fileList[i].response){   //如果有 response 这个属性则为添加的图片
                                let obj = this.fileList[i].response.data
                                data.imageIdArray.push(obj)
                            } else {
                                imgArrayList.push(this.fileList[i])
                            }

                        }
                        //处理数组  找出所有删除图片的数组
                        for(var i = 0; i < copyFileList.length; i++){
                            var obj = copyFileList[i];
                            var num = obj.photo_id;
                            var flag = false;
                            for(var j = 0; j < imgArrayList.length; j++){
                                var aj = imgArrayList[j];
                                var n = aj.photo_id;
                                if(n === num){
                                    flag = true;
                                    break;
                                }
                            }
                            if(!flag){
                                data.deleteImageIdArray.push(obj);
                            }
                        }

                        await http.post('/wapi/Business/addOrEditTodoByDistributor',data).then(res=>{
                            if(res.success == true){
                                this.init()
                                this.$message({
                                    type:'success',
                                    message:'保存成功'
                                })
                                this.addTodoBool = false
                            }
                        })
                    }

                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            editorTodoList(item){
                console.log(item)
                this.addTodo = JSON.parse(JSON.stringify(item))
                this.addTodo.distributor_name=this.title
                this.fileList = item.photoList
                this.copyFileList = JSON.parse(JSON.stringify(item.photoList))

            },
            //通过图片id获取图片
            async getImgUrl(id,date,item,arr) {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }
                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data
                    item.url = array[0].thu_url
                    this.sortKey(arr, "created_date")
                    this.$forceUpdate()

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            sortKey(array, key) {
                return array.sort(function(a, b) {
                    var x = a[key];
                    var y = b[key];
                    return x > y ? 1 : x < y ? -1 : 0;
                });
            },
            closeAddTodoBool(){
                this.addTodoBool=false
                this.$refs['formlist'].resetFields()
            }
        }
    }

</script>

<style scoped>
    #inventory >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #inventory >>>.el-dialog__body{
        padding-top:0;
        padding-bottom: 30px;
    }
    #addTodo >>> .el-form-item{
        margin-top: 20px;
    }
    #addTodo >>> .el-form-item__error{
        margin-left: 28px;
    }
    #addTodo >>> .addTodoList_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    #addTodo >>> .el-button--danger {
        color: #FFF;
        background-color: #ED3B3F;
        border-color: #ED3B3F;
    }
    #addTodo >>> .el-button--danger:hover {
        color: #FFF;
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    #addTodo >>> .el-button--small {
        padding: 9px 12px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/components/addTodoList.vue